import LectureStudentsPage from "../../features/dashboard/LectureStudents/LectureStudentsPage"

const LectureStudents = () => {
    return (
        <LectureStudentsPage />
    )
}

export default LectureStudents